import { TrackingEventName } from '@/models/analytics/eventTypes';
import type {
  CancelFlowOpenedEventProps,
  CancelOfferEventProps,
  CancelReasonSelectedEventProps,
} from '@/models/analytics/features/payments';
import {
  trackCheckoutStartedSpec,
  trackPaymentCompletedSpec,
  trackPaymentStartedSpec,
  trackPaywallViewedSpec,
  trackSubscriptionCreatedSpec,
  trackSubscriptionEventSpec,
  trackTrialCompletedSpec,
  trackTrialStartedSpec,
  type CheckoutStarted,
  type PaymentCompleted,
  type PaymentStarted,
  type PaywallViewed,
  type SubscriptionCreated,
  type SubscriptionEvent,
  type TrialCompleted,
  type TrialStarted,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const paymentEvents: SnowplowEventMap = {
  [TrackingEventName.SubscriptionCreated]: (props) =>
    trackSubscriptionCreatedSpec(props as SubscriptionCreated),
  [TrackingEventName.CheckoutStarted]: (props) =>
    trackCheckoutStartedSpec(props as CheckoutStarted),
  [TrackingEventName.PaymentStarted]: (props) =>
    trackPaymentStartedSpec(props as PaymentStarted),
  [TrackingEventName.PaymentCompleted]: (props) =>
    trackPaymentCompletedSpec(props as PaymentCompleted),
  [TrackingEventName.PaywallViewed]: (props) =>
    trackPaywallViewedSpec(props as PaywallViewed),
  [TrackingEventName.TrialStarted]: (props) =>
    trackTrialStartedSpec(props as TrialStarted),
  [TrackingEventName.TrialCompleted]: (props) =>
    trackTrialCompletedSpec(props as TrialCompleted),
  [TrackingEventName.CancelFlowOpened]: (props) =>
    trackSubscriptionEventSpec({
      subscription_action: 'cancel_flow_opened',
      ...(props as CancelFlowOpenedEventProps),
    } as SubscriptionEvent),
  [TrackingEventName.CancelReasonSelected]: (props) =>
    trackSubscriptionEventSpec({
      subscription_action: 'cancel_reason_selected',
      ...(props as CancelReasonSelectedEventProps),
    } as SubscriptionEvent),
  [TrackingEventName.CancelOfferShown]: (props) =>
    trackSubscriptionEventSpec({
      subscription_action: 'cancel_offer_shown',
      ...(props as CancelOfferEventProps),
    } as SubscriptionEvent),
  [TrackingEventName.CancelOfferAccepted]: (props) =>
    trackSubscriptionEventSpec({
      subscription_action: 'cancel_offer_accepted',
      ...(props as CancelOfferEventProps),
    } as SubscriptionEvent),
  [TrackingEventName.CancelOfferDeclined]: (props) =>
    trackSubscriptionEventSpec({
      subscription_action: 'cancel_offer_declined',
      ...(props as CancelOfferEventProps),
    } as SubscriptionEvent),
};
